import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 获取投诉建议列表（旧接口，保留兼容）
export function listAdminComplaints(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/complaint.listAdminComplaints',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data,
          total: res.total
        })
      } else {
        reject(new Error(res.msg || 'Failed to get complaint list'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取管理员小区列表
export function listAdminCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.listAdminCommunitys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data
        })
      } else {
        reject(new Error(res.msg || 'Failed to get community list'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 投诉工单列表（新接口 pms.queryComplaintOrder，参考小程序 queryComplaintOrder 实现）
 * 说明：
 * - 默认使用当前小区 communityId，可通过参数覆盖
 * - 默认 initiatorType 为 '1'（员工端）
 * - 返回统一结构 { data, total }，方便列表和分页使用
 */
export function listComplaintOrders(params = {}) {
  return new Promise((resolve, reject) => {
    const baseParams = {
      communityId: params.communityId || getCommunityId(),
      page: params.page || 1,
      row: params.row || 10
    }

    const queryParams = { ...baseParams, initiatorType: params.initiatorType !== undefined ? params.initiatorType : 1, ...params }

    request({
      url: '/app/pms.queryComplaintOrder',
      method: 'get',
      params: queryParams
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const list = Array.isArray(res.data) ? res.data : []
        const total = typeof res.total === 'number'
          ? res.total
          : (typeof res.records === 'number' ? res.records : list.length)
        resolve({
          data: list,
          total
        })
      } else {
        reject(new Error(res.msg || 'Failed to get complaint order list'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存或更新投诉工单（用于“立即处理”等操作）
export function saveOrUpdateComplaintOrder(data) {
  return new Promise((resolve, reject) => {
    const payload = {
      ...data
    }
    if (!payload.communityId) {
      payload.communityId = getCommunityId()
    }

    request({
      url: '/app/pms.saveOrUpdateComplaintOrder',
      method: 'post',
      data: payload
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to save complaint order'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}